"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importStar(require("../IconContainer"));
const StyledPath = styled_components_1.default.path `
  fill: ${({ theme, color }) => color || theme.palette.primary.main};
`;
const RestartIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, color, ...rest }) => ((0, jsx_runtime_1.jsx)("svg", { fill: "none", height: size, viewBox: "0 0 16 16", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: (0, jsx_runtime_1.jsx)(StyledPath, { color: color, d: "M13.3392 6.16667L7.76816 11.8333L6.52397 10.6101L10.3308 6.9582H0.00585938V5.37513H10.3308L6.52397 1.72328L7.76816 0.5L13.3392 6.16667Z" }) }));
exports.default = (0, IconContainer_1.default)(RestartIcon);
//# sourceMappingURL=index.js.map